import { Inject, Injectable } from '@angular/core'
import { HttpClient, HttpResponse } from '@angular/common/http'
import { switchMap, tap } from 'rxjs/operators'
import { Observable } from 'rxjs'
import { resetStores } from '@datorama/akita'
import type { PersistState } from '@datorama/akita'
import { PERSIST_STORAGE } from '@app/core/tokens/injection-tokens'
import { SessionStore } from './session.store'
import { User, UserLoginData } from './session.model'

@Injectable({ providedIn: 'root' })
export class SessionService {
  constructor(
    private sessionStore: SessionStore,
    private http: HttpClient,
    @Inject(PERSIST_STORAGE) private persistStorage: PersistState,
  ) {}

  private loadUser(): Observable<User> {
    return this.http.get<User>('./Api/Core/Auth').pipe(
      tap(user => {
        this.sessionStore.update({ user })
      }),
    )
  }

  login(data: UserLoginData): Observable<User> {
    return this.http.post('./Api/Core/Auth/Login', data).pipe(switchMap(() => this.loadUser()))
  }

  logout(): void {
    this.http
      .post<HttpResponse<null>>('./Api/Core/Auth/Logout', {})
      .pipe(tap({ next: () => this.clearUserAndStorages() }))
      .subscribe()
  }

  clearUserAndStorages(): void {
    resetStores()
    this.persistStorage.clearStore()
    this.sessionStore.update({ user: null })
  }
}
